import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Segmentqmq1glevgieu as Segment,
  closefimrnzr4lu35 as close,
  findSegmentInternal35lxp6iondi3q as findSegmentInternal,
  _SegmentOrClosed___get_segment__impl__jvcr9l11u92xgdpd2cq as _SegmentOrClosed___get_segment__impl__jvcr9l,
  _SegmentOrClosed___get_isClosed__impl__qmxmlo29t7w5c5hyyi1 as _SegmentOrClosed___get_isClosed__impl__qmxmlo,
  SegmentOrCloseds3xpxfs4wrg9 as SegmentOrClosed,
} from '../internal/ConcurrentLinkedList.mjs';
import { atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.common.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Waiter3lxa2a79zyo0g as Waiter } from '../Waiter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  callUndeliveredElement5xsmnofvtcme as callUndeliveredElement,
  callUndeliveredElementCatchingException6xwxmojd3rq1 as callUndeliveredElementCatchingException,
} from '../internal/OnUndeliveredElement.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  convertToInty04h231mmjoh as convertToInt,
  shiftRight2gqph14wydb8s as shiftRight,
  subtract2orl8z9upxd9l as subtract,
  shiftLeft3tsh2sstjchzn as shiftLeft,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  recoverStackTrace3k4hvtb53ci4z as recoverStackTrace,
  recoverStackTrace2i3si2i8nvw1k as recoverStackTrace_0,
} from '../internal/StackTraceRecovery.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  getOrCreateCancellableContinuation2t1o0dr9l9i36 as getOrCreateCancellableContinuation,
  CancellableContinuationpb2x00mxmcbt as CancellableContinuation,
} from '../CancellableContinuation.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../CancellableContinuationImpl.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  Companion_getInstance2d24j5bn8excb as Companion_getInstance,
  ChannelResult2y4k69ac6y3du as ChannelResult,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  ChannelResult__getOrNull_impl_f5e07h25z6we1ochnsd as ChannelResult__getOrNull_impl_f5e07h,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  close$default1evna6yun3t5h as close$default,
  cancel$default1fq6eekptkf7a as cancel$default,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import {
  SelectInstance2isepgzfsd8ur as SelectInstance,
  SelectImplementation59ci94k9x9wm as SelectImplementation,
  TrySelectDetailedResult_REREGISTER_getInstance15xg23166dzwi as TrySelectDetailedResult_REREGISTER_getInstance,
  TrySelectDetailedResult_SUCCESSFUL_getInstanceuly24xhbmack as TrySelectDetailedResult_SUCCESSFUL_getInstance,
} from '../selects/Select.mjs';
import {
  _InlineList___init__impl__z8n563fbquki2pbrg9 as _InlineList___init__impl__z8n56,
  InlineList__plus_impl_nuetvo19qcbi592j2ja as InlineList__plus_impl_nuetvo,
  access$_get_holder__kkflengpb3tkfr49xk as access$_get_holder__kkflen,
} from '../internal/InlineList.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { last2n4gf5az1lkn4 as last } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { systemProp2qpti4y1f5b4b as systemProp } from '../internal/SystemProps.common.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from '../internal/Symbol.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL_SEGMENT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NULL_SEGMENT;
}
var NULL_SEGMENT;
function get_SEGMENT_SIZE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SEGMENT_SIZE;
}
var SEGMENT_SIZE;
function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
}
var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
function get_BUFFERED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return BUFFERED;
}
var BUFFERED;
function get_IN_BUFFER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return IN_BUFFER;
}
var IN_BUFFER;
function get_RESUMING_BY_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_RCV;
}
var RESUMING_BY_RCV;
function get_RESUMING_BY_EB() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_EB;
}
var RESUMING_BY_EB;
function get_POISONED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return POISONED;
}
var POISONED;
function get_DONE_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return DONE_RCV;
}
var DONE_RCV;
function get_INTERRUPTED_SEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_SEND;
}
var INTERRUPTED_SEND;
function get_INTERRUPTED_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_RCV;
}
var INTERRUPTED_RCV;
function get_CHANNEL_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CHANNEL_CLOSED;
}
var CHANNEL_CLOSED;
function get_SUSPEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND;
}
var SUSPEND;
function get_SUSPEND_NO_WAITER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND_NO_WAITER;
}
var SUSPEND_NO_WAITER;
function get_FAILED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return FAILED;
}
var FAILED;
function get_NO_RECEIVE_RESULT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_RECEIVE_RESULT;
}
var NO_RECEIVE_RESULT;
function get_CLOSE_HANDLER_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_CLOSED;
}
var CLOSE_HANDLER_CLOSED;
function get_CLOSE_HANDLER_INVOKED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_INVOKED;
}
var CLOSE_HANDLER_INVOKED;
function get_NO_CLOSE_CAUSE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_CLOSE_CAUSE;
}
var NO_CLOSE_CAUSE;
function setElementLazy($this, index, value) {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  $this.d18_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
}
var ChannelSegmentClass;
function ChannelSegment() {
  if (ChannelSegmentClass === VOID) {
    class $ extends Segment() {
      constructor(id, prev, channel, pointers) {
        super(id, prev, pointers);
        this.c18_1 = channel;
        this.d18_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
      }
      e18() {
        return ensureNotNull(this.c18_1);
      }
      f18() {
        return get_SEGMENT_SIZE();
      }
      g18(index, element) {
        setElementLazy(this, index, element);
      }
      h18(index) {
        return this.d18_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
      }
      i18(index) {
        // Inline function 'kotlin.also' call
        var this_0 = this.h18(index);
        this.j18(index);
        return this_0;
      }
      j18(index) {
        setElementLazy(this, index, null);
      }
      k18(index) {
        return this.d18_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
      }
      l18(index, value) {
        this.d18_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
      }
      m18(index, from, to) {
        return this.d18_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
      }
      n18(index, update) {
        return this.d18_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
      }
      f10(index, cause, context) {
        var isSender = index >= get_SEGMENT_SIZE();
        var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
        var element = this.h18(index_0);
        $l$loop: while (true) {
          var cur = this.k18(index_0);
          var tmp;
          if (!(cur == null) ? isInterface(cur, Waiter()) : false) {
            tmp = true;
          } else {
            tmp = cur instanceof WaiterEB();
          }
          if (tmp) {
            var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
            if (this.m18(index_0, cur, update)) {
              this.j18(index_0);
              this.a19(index_0, !isSender);
              if (isSender) {
                var tmp0_safe_receiver = this.e18().p18_1;
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  callUndeliveredElement(tmp0_safe_receiver, element, context);
                }
              }
              return Unit_instance;
            }
          } else {
            if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
              this.j18(index_0);
              if (isSender) {
                var tmp1_safe_receiver = this.e18().p18_1;
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  callUndeliveredElement(tmp1_safe_receiver, element, context);
                }
              }
              return Unit_instance;
            } else {
              if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
                continue $l$loop;
              else {
                if (cur === get_DONE_RCV() || cur === get_BUFFERED())
                  return Unit_instance;
                else {
                  if (cur === get_CHANNEL_CLOSED())
                    return Unit_instance;
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'unexpected state: ' + toString(cur);
                    throw IllegalStateException().o(toString_0(message));
                  }
                }
              }
            }
          }
        }
      }
      a19(index, receiver) {
        if (receiver) {
          var tmp = this.e18();
          var tmp0 = this.d10_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply(tmp0, fromInt(other));
          var tmp$ret$1 = add(this_0, fromInt(index));
          tmp.b19(tmp$ret$1);
        }
        this.c19();
      }
    }
    initMetadataForClass($, 'ChannelSegment');
    ChannelSegmentClass = $;
  }
  return ChannelSegmentClass;
}
function onClosedHasNext($this) {
  $this.o19_1 = get_CHANNEL_CLOSED();
  var tmp0_elvis_lhs = $this.q19_1.r19();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cause = tmp;
  throw recoverStackTrace(cause);
}
function *hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      $this.p19_1 = cancellable;
      var tmp0 = $this.q19_1;
      var tmp2 = segment;
      var tmp4 = index;
      var tmp6 = r;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var waiter = $this;
      var updCellResult = updateCellReceive(tmp0, tmp2, tmp4, tmp6, waiter);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(tmp0, waiter, tmp2, tmp4);
      } else if (updCellResult === get_FAILED()) {
        if (tmp6 < tmp0.s19()) {
          tmp2.m19();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = tmp0.v18_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (tmp0.t19()) {
              onClosedHasNextNoWaiterSuspend($this);
              break $l$block_0;
            }
            var r_0 = tmp0.r18_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$8 = modulo(r_0, fromInt(other_0));
            var i = convertToInt(tmp$ret$8);
            if (!(segment_0.d10_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(tmp0, segment_0, i, r_0, waiter);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter()) : false) ? waiter : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_0 < tmp0.s19()) {
                segment_0.m19();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException().o(toString_0(message));
            } else {
              segment_0.m19();
              $this.o19_1 = updCellResult_0;
              $this.p19_1 = null;
              var tmp0_safe_receiver = $this.q19_1.p18_1;
              cancellable.h11(true, tmp0_safe_receiver == null ? null : bindCancellationFun($this.q19_1, tmp0_safe_receiver, updCellResult_0));
            }
            break $l$block_0;
          }
        }
      } else {
        tmp2.m19();
        $this.o19_1 = updCellResult;
        $this.p19_1 = null;
        var tmp0_safe_receiver_0 = $this.q19_1.p18_1;
        cancellable.h11(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun($this.q19_1, tmp0_safe_receiver_0, updCellResult));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.d11();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.fy();
  };
}
function onClosedHasNextNoWaiterSuspend($this) {
  var cont = ensureNotNull($this.p19_1);
  $this.p19_1 = null;
  $this.o19_1 = get_CHANNEL_CLOSED();
  var cause = $this.q19_1.r19();
  if (cause == null) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
    cont.oc(tmp$ret$1);
  } else {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace_0(cause, cont);
    var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.oc(tmp$ret$3);
  }
}
function _get_bufferEndCounter__2d4hee($this) {
  return $this.s18_1.kotlinx$atomicfu$value;
}
function _get_isRendezvousOrUnlimited__3mdufi($this) {
  // Inline function 'kotlin.let' call
  var it = _get_bufferEndCounter__2d4hee($this);
  return it === 0n || it === 9223372036854775807n;
}
function *onClosedSend($this, element, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.v10();
    $l$block: {
      var tmp0_safe_receiver = $this.p18_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, $this.u19());
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = recoverStackTrace_0(tmp1_safe_receiver, cancellable);
        var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
        cancellable.oc(tmp$ret$7);
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      var exception_0 = $this.u19();
      // Inline function 'kotlin.Companion.failure' call
      var exception_1 = recoverStackTrace_0(exception_0, cancellable);
      var tmp$ret$9 = _Result___init__impl__xyqfz8(createFailure(exception_1));
      cancellable.oc(tmp$ret$9);
    }
    return cancellable.fy();
  });
  return Unit_instance;
}
function *sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var tmp0 = $this;
      var tmp2 = segment;
      var tmp4 = index;
      var tmp6 = element;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
      var s_0 = s;
      switch (updateCellSend(tmp0, tmp2, tmp4, tmp6, s_0, cancellable, false)) {
        case 0:
          tmp2.m19();
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.oc(tmp$ret$7);
          break;
        case 1:
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.oc(tmp$ret$10);
          break;
        case 2:
          prepareSenderForSuspension(tmp0, cancellable, tmp2, tmp4);
          break;
        case 4:
          if (s_0 < tmp0.v19()) {
            tmp2.m19();
          }

          onClosedSendOnNoWaiterSuspend($this, element, cancellable);
          break;
        case 5:
          tmp2.m19();
          $l$block_5: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var segment_0 = tmp0.u18_1.kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              var sendersAndCloseStatusCur = tmp0.q18_1.atomicfu$getAndIncrement$long();
              // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
              var s_1 = sendersAndCloseStatusCur & 1152921504606846975n;
              var closed = _get_isClosedForSend0__kxgf9m(tmp0, sendersAndCloseStatusCur);
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = divide(s_1, fromInt(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var tmp$ret$15 = modulo(s_1, fromInt(other_0));
              var i = convertToInt(tmp$ret$15);
              if (!(segment_0.d10_1 === id)) {
                var tmp0_elvis_lhs = findSegmentSend(tmp0, id, segment_0);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  var tmp_0;
                  if (closed) {
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  } else {
                    continue $l$loop_0;
                  }
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                segment_0 = tmp;
              }
              switch (updateCellSend(tmp0, segment_0, i, tmp6, s_1, cancellable, closed)) {
                case 0:
                  segment_0.m19();
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$19 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.oc(tmp$ret$19);
                  break $l$block_5;
                case 1:
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$22 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.oc(tmp$ret$22);
                  break $l$block_5;
                case 2:
                  if (closed) {
                    segment_0.c19();
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  }

                  var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter()) : false) ? cancellable : null;
                  if (tmp2_safe_receiver == null)
                    null;
                  else {
                    prepareSenderForSuspension(tmp0, tmp2_safe_receiver, segment_0, i);
                  }

                  break $l$block_5;
                case 4:
                  if (s_1 < tmp0.v19()) {
                    segment_0.m19();
                  }

                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                case 5:
                  segment_0.m19();
                  continue $l$loop_0;
                case 3:
                  // Inline function 'kotlin.error' call

                  var message = 'unexpected';
                  throw IllegalStateException().o(toString_0(message));
              }
            }
          }

          break;
        default:
          // Inline function 'kotlin.error' call

          var message_0 = 'unexpected';
          throw IllegalStateException().o(toString_0(message_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.d11();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.fy();
  });
  return Unit_instance;
}
function prepareSenderForSuspension($this, $receiver, segment, index) {
  $receiver.j11(segment, index + get_SEGMENT_SIZE() | 0);
}
function onClosedSendOnNoWaiterSuspend($this, element, cont) {
  var tmp0_safe_receiver = $this.p18_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    callUndeliveredElement(tmp0_safe_receiver, element, cont.mc());
  }
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = recoverStackTrace_0($this.u19(), cont);
  var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.oc(tmp$ret$1);
}
var SendBroadcastClass;
function SendBroadcast() {
  if (SendBroadcastClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SendBroadcast', VOID, VOID, [Waiter()]);
    SendBroadcastClass = $;
  }
  return SendBroadcastClass;
}
function updateCellSend($this, segment, index, element, s, waiter, closed) {
  segment.g18(index, element);
  if (closed)
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  var state = segment.k18(index);
  if (state === null) {
    if (bufferOrRendezvousSend($this, s)) {
      if (segment.m18(index, null, get_BUFFERED())) {
        return 1;
      }
    } else {
      if (waiter == null) {
        return 3;
      } else {
        if (segment.m18(index, null, waiter))
          return 2;
      }
    }
  } else {
    if (!(state == null) ? isInterface(state, Waiter()) : false) {
      segment.j18(index);
      var tmp;
      if (tryResumeReceiver($this, state, element)) {
        segment.l18(index, get_DONE_RCV());
        $this.w19();
        tmp = 0;
      } else {
        if (!(segment.n18(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.a19(index, true);
        }
        tmp = 5;
      }
      return tmp;
    }
  }
  return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
}
function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
  while (true) {
    var state = segment.k18(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s) && !closed) {
        if (segment.m18(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (closed) {
          if (segment.m18(index, null, get_INTERRUPTED_SEND())) {
            segment.a19(index, false);
            return 4;
          }
        } else if (waiter == null)
          return 3;
        else if (segment.m18(index, null, waiter))
          return 2;
      }
    } else if (state === get_IN_BUFFER()) {
      if (segment.m18(index, state, get_BUFFERED())) {
        return 1;
      }
    } else if (state === get_INTERRUPTED_RCV()) {
      segment.j18(index);
      return 5;
    } else if (state === get_POISONED()) {
      segment.j18(index);
      return 5;
    } else if (state === get_CHANNEL_CLOSED()) {
      segment.j18(index);
      completeCloseOrCancel($this);
      return 4;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      segment.j18(index);
      var tmp;
      if (state instanceof WaiterEB()) {
        tmp = state.x19_1;
      } else {
        tmp = state;
      }
      var receiver = tmp;
      var tmp_0;
      if (tryResumeReceiver($this, receiver, element)) {
        segment.l18(index, get_DONE_RCV());
        $this.w19();
        tmp_0 = 0;
      } else {
        if (!(segment.n18(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.a19(index, true);
        }
        tmp_0 = 5;
      }
      return tmp_0;
    }
  }
}
function shouldSendSuspend0($this, curSendersAndCloseStatus) {
  if (_get_isClosedForSend0__kxgf9m($this, curSendersAndCloseStatus))
    return false;
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  var tmp$ret$0 = curSendersAndCloseStatus & 1152921504606846975n;
  return !bufferOrRendezvousSend($this, tmp$ret$0);
}
function bufferOrRendezvousSend($this, curSenders) {
  var tmp;
  if (curSenders < _get_bufferEndCounter__2d4hee($this)) {
    tmp = true;
  } else {
    var tmp0 = $this.v19();
    // Inline function 'kotlin.Long.plus' call
    var other = $this.o18_1;
    tmp = curSenders < add(tmp0, fromInt(other));
  }
  return tmp;
}
function tryResumeReceiver($this, $receiver, element) {
  var tmp;
  if (isInterface($receiver, SelectInstance())) {
    tmp = $receiver.c1a($this, element);
  } else {
    if ($receiver instanceof ReceiveCatching()) {
      if (!($receiver instanceof ReceiveCatching()))
        THROW_CCE();
      var tmp_0 = Companion_getInstance().a1a(element);
      var tmp1_safe_receiver = $this.p18_1;
      tmp = tryResume0($receiver.b1a_1, new (ChannelResult())(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFunResult($this, tmp1_safe_receiver));
    } else {
      if ($receiver instanceof BufferedChannelIterator()) {
        if (!($receiver instanceof BufferedChannelIterator()))
          THROW_CCE();
        tmp = $receiver.y19(element);
      } else {
        if (isInterface($receiver, CancellableContinuation())) {
          if (!isInterface($receiver, CancellableContinuation()))
            THROW_CCE();
          var tmp2_safe_receiver = $this.p18_1;
          tmp = tryResume0($receiver, element, tmp2_safe_receiver == null ? null : bindCancellationFun_0($this, tmp2_safe_receiver));
        } else {
          // Inline function 'kotlin.error' call
          var message = 'Unexpected receiver type: ' + toString_0($receiver);
          throw IllegalStateException().o(toString_0(message));
        }
      }
    }
  }
  return tmp;
}
function *receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var tmp0 = $this;
      var tmp2 = segment;
      var tmp4 = index;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var r_0 = r;
      var updCellResult = updateCellReceive(tmp0, tmp2, tmp4, r_0, cancellable);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(tmp0, cancellable, tmp2, tmp4);
      } else if (updCellResult === get_FAILED()) {
        if (r_0 < tmp0.s19()) {
          tmp2.m19();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = tmp0.v18_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (tmp0.t19()) {
              onClosedReceiveOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_1 = tmp0.r18_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_1, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$8 = modulo(r_1, fromInt(other_0));
            var i = convertToInt(tmp$ret$8);
            if (!(segment_0.d10_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(tmp0, segment_0, i, r_1, cancellable);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter()) : false) ? cancellable : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_1 < tmp0.s19()) {
                segment_0.m19();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException().o(toString_0(message));
            } else {
              segment_0.m19();
              var tmp0_safe_receiver = $this.p18_1;
              var onCancellation = tmp0_safe_receiver == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver);
              cancellable.h11(updCellResult_0, onCancellation);
            }
            break $l$block_0;
          }
        }
      } else {
        tmp2.m19();
        var tmp0_safe_receiver_0 = $this.p18_1;
        var onCancellation_0 = tmp0_safe_receiver_0 == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver_0);
        cancellable.h11(updCellResult, onCancellation_0);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.d11();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.fy();
  };
}
function prepareReceiverForSuspension($this, $receiver, segment, index) {
  $this.d1a();
  $receiver.j11(segment, index);
}
function onClosedReceiveOnNoWaiterSuspend($this, cont) {
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = _get_receiveException__foorc1($this);
  var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.oc(tmp$ret$1);
}
function updateCellReceive($this, segment, index, r, waiter) {
  var state = segment.k18(index);
  if (state === null) {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var senders = $this.q18_1.kotlinx$atomicfu$value & 1152921504606846975n;
    if (r >= senders) {
      if (waiter === null) {
        return get_SUSPEND_NO_WAITER();
      }
      if (segment.m18(index, state, waiter)) {
        expandBuffer($this);
        return get_SUSPEND();
      }
    }
  } else if (state === get_BUFFERED())
    if (segment.m18(index, state, get_DONE_RCV())) {
      expandBuffer($this);
      return segment.i18(index);
    }
  return updateCellReceiveSlow($this, segment, index, r, waiter);
}
function updateCellReceiveSlow($this, segment, index, r, waiter) {
  $l$loop: while (true) {
    var state = segment.k18(index);
    if (state === null || state === get_IN_BUFFER()) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var senders = $this.q18_1.kotlinx$atomicfu$value & 1152921504606846975n;
      if (r < senders) {
        if (segment.m18(index, state, get_POISONED())) {
          expandBuffer($this);
          return get_FAILED();
        }
      } else {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.m18(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED()) {
      if (segment.m18(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.i18(index);
      }
    } else if (state === get_INTERRUPTED_SEND())
      return get_FAILED();
    else if (state === get_POISONED())
      return get_FAILED();
    else if (state === get_CHANNEL_CLOSED()) {
      expandBuffer($this);
      return get_FAILED();
    } else if (state === get_RESUMING_BY_EB())
      continue $l$loop;
    else {
      if (segment.m18(index, state, get_RESUMING_BY_RCV())) {
        var helpExpandBuffer = state instanceof WaiterEB();
        var tmp;
        if (state instanceof WaiterEB()) {
          tmp = state.x19_1;
        } else {
          tmp = state;
        }
        var sender = tmp;
        var tmp_0;
        if (tryResumeSender($this, sender, segment, index)) {
          segment.l18(index, get_DONE_RCV());
          expandBuffer($this);
          tmp_0 = segment.i18(index);
        } else {
          segment.l18(index, get_INTERRUPTED_SEND());
          segment.a19(index, false);
          if (helpExpandBuffer) {
            expandBuffer($this);
          }
          tmp_0 = get_FAILED();
        }
        return tmp_0;
      }
    }
  }
}
function tryResumeSender($this, $receiver, segment, index) {
  var tmp;
  if (isInterface($receiver, CancellableContinuation())) {
    if (!isInterface($receiver, CancellableContinuation()))
      THROW_CCE();
    tmp = tryResume0($receiver, Unit_instance);
  } else {
    if (isInterface($receiver, SelectInstance())) {
      if (!($receiver instanceof SelectImplementation()))
        THROW_CCE();
      var trySelectResult = $receiver.i1a($this, Unit_instance);
      if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
        segment.j18(index);
      }
      tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
    } else {
      if ($receiver instanceof SendBroadcast()) {
        tmp = tryResume0($receiver.e1a_1, true);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'Unexpected waiter: ' + toString_0($receiver);
        throw IllegalStateException().o(toString_0(message));
      }
    }
  }
  return tmp;
}
function expandBuffer($this) {
  if (_get_isRendezvousOrUnlimited__3mdufi($this))
    return Unit_instance;
  var segment = $this.w18_1.kotlinx$atomicfu$value;
  try_again: while (true) {
    var b = $this.s18_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = divide(b, fromInt(other));
    var s = $this.s19();
    if (s <= b) {
      if (segment.d10_1 < id && !(segment.i19() == null)) {
        moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
      }
      incCompletedExpandBufferAttempts($this);
      return Unit_instance;
    }
    if (!(segment.d10_1 === id)) {
      var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue try_again;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var tmp$ret$1 = modulo(b, fromInt(other_0));
    var i = convertToInt(tmp$ret$1);
    if (updateCellExpandBuffer($this, segment, i, b)) {
      incCompletedExpandBufferAttempts($this);
      return Unit_instance;
    } else {
      incCompletedExpandBufferAttempts($this);
      continue try_again;
    }
  }
}
function updateCellExpandBuffer($this, segment, index, b) {
  var state = segment.k18(index);
  if (!(state == null) ? isInterface(state, Waiter()) : false) {
    if (b >= $this.r18_1.kotlinx$atomicfu$value) {
      if (segment.m18(index, state, get_RESUMING_BY_EB())) {
        var tmp;
        if (tryResumeSender($this, state, segment, index)) {
          segment.l18(index, get_BUFFERED());
          tmp = true;
        } else {
          segment.l18(index, get_INTERRUPTED_SEND());
          segment.a19(index, false);
          tmp = false;
        }
        return tmp;
      }
    }
  }
  return updateCellExpandBufferSlow($this, segment, index, b);
}
function updateCellExpandBufferSlow($this, segment, index, b) {
  $l$loop: while (true) {
    var state = segment.k18(index);
    if (!(state == null) ? isInterface(state, Waiter()) : false) {
      if (b < $this.r18_1.kotlinx$atomicfu$value) {
        if (segment.m18(index, state, new (WaiterEB())(state)))
          return true;
      } else {
        if (segment.m18(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender($this, state, segment, index)) {
            segment.l18(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.l18(index, get_INTERRUPTED_SEND());
            segment.a19(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    } else {
      if (state === get_INTERRUPTED_SEND())
        return false;
      else {
        if (state === null) {
          if (segment.m18(index, state, get_IN_BUFFER()))
            return true;
        } else {
          if (state === get_BUFFERED())
            return true;
          else {
            if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
              return true;
            else {
              if (state === get_CHANNEL_CLOSED())
                return true;
              else {
                if (state === get_RESUMING_BY_RCV())
                  continue $l$loop;
                else {
                  // Inline function 'kotlin.error' call
                  var message = 'Unexpected cell state: ' + toString(state);
                  throw IllegalStateException().o(toString_0(message));
                }
              }
            }
          }
        }
      }
    }
  }
}
function incCompletedExpandBufferAttempts($this, nAttempts) {
  nAttempts = nAttempts === VOID ? 1n : nAttempts;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
  if (!(($this.t18_1.atomicfu$addAndGet$long(nAttempts) & 4611686018427387904n) === 0n)) {
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      if (!!(($this.t18_1.kotlinx$atomicfu$value & 4611686018427387904n) === 0n)) {
        break $l$loop;
      }
    }
  }
}
var BufferedChannelIteratorClass;
function BufferedChannelIterator() {
  if (BufferedChannelIteratorClass === VOID) {
    class $ {
      constructor($outer) {
        this.q19_1 = $outer;
        this.o19_1 = get_NO_RECEIVE_RESULT();
        this.p19_1 = null;
      }
      *j1a($completion) {
        var tmp;
        if (!(this.o19_1 === get_NO_RECEIVE_RESULT()) && !(this.o19_1 === get_CHANNEL_CLOSED())) {
          tmp = true;
        } else {
          var tmp0 = this.q19_1;
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
            var segment = tmp0.v18_1.kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              if (tmp0.t19()) {
                tmp$ret$0 = onClosedHasNext(this);
                break $l$block_0;
              }
              var r = tmp0.r18_1.atomicfu$getAndIncrement$long();
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = divide(r, fromInt(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var tmp$ret$3 = modulo(r, fromInt(other_0));
              var i = convertToInt(tmp$ret$3);
              if (!(segment.d10_1 === id)) {
                var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment);
                var tmp_0;
                if (tmp0_elvis_lhs == null) {
                  continue $l$loop_0;
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                segment = tmp_0;
              }
              var updCellResult = updateCellReceive(tmp0, segment, i, r, null);
              var tmp_1;
              if (updCellResult === get_SUSPEND()) {
                var tmp1_safe_receiver = (!(null == null) ? isInterface(null, Waiter()) : false) ? null : null;
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment, i);
                }
                // Inline function 'kotlin.error' call
                var message = 'unreachable';
                throw IllegalStateException().o(toString_0(message));
              } else if (updCellResult === get_FAILED()) {
                if (r < tmp0.s19()) {
                  segment.m19();
                }
                continue $l$loop_0;
              } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
                var segm = segment;
                return yield* /*#__NOINLINE__*/hasNextOnNoWaiterSuspend(this, segm, i, r, $completion);
              } else {
                segment.m19();
                this.o19_1 = updCellResult;
                tmp_1 = true;
              }
              tmp$ret$0 = tmp_1;
              break $l$block_0;
            }
          }
          tmp = tmp$ret$0;
        }
        return tmp;
      }
      j11(segment, index) {
        var tmp0_safe_receiver = this.p19_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.j11(segment, index);
        }
      }
      r1() {
        var result = this.o19_1;
        // Inline function 'kotlin.check' call
        if (!!(result === get_NO_RECEIVE_RESULT())) {
          var message = '`hasNext()` has not been invoked';
          throw IllegalStateException().o(toString_0(message));
        }
        this.o19_1 = get_NO_RECEIVE_RESULT();
        if (result === get_CHANNEL_CLOSED())
          throw recoverStackTrace(_get_receiveException__foorc1(this.q19_1));
        return result;
      }
      y19(element) {
        var cont = ensureNotNull(this.p19_1);
        this.p19_1 = null;
        this.o19_1 = element;
        var tmp0_safe_receiver = this.q19_1.p18_1;
        return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(this.q19_1, tmp0_safe_receiver, element));
      }
      k1a() {
        var cont = ensureNotNull(this.p19_1);
        this.p19_1 = null;
        this.o19_1 = get_CHANNEL_CLOSED();
        var cause = this.q19_1.r19();
        if (cause == null) {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
          cont.oc(tmp$ret$1);
        } else {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = recoverStackTrace_0(cause, cont);
          var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
          cont.oc(tmp$ret$3);
        }
      }
    }
    initMetadataForClass($, 'BufferedChannelIterator', VOID, VOID, [Waiter()], [0, 3]);
    BufferedChannelIteratorClass = $;
  }
  return BufferedChannelIteratorClass;
}
function _get_receiveException__foorc1($this) {
  var tmp0_elvis_lhs = $this.r19();
  return tmp0_elvis_lhs == null ? ClosedReceiveChannelException().p1a('Channel was closed') : tmp0_elvis_lhs;
}
function invokeCloseHandler($this) {
  var tmp0 = $this.z18_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.getAndUpdate' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      if (cur === null) {
        tmp = get_CLOSE_HANDLER_CLOSED();
      } else {
        tmp = get_CLOSE_HANDLER_INVOKED();
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = cur;
        break $l$block;
      }
    }
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var closeHandler = tmp_0;
  if (typeof closeHandler !== 'function')
    THROW_CCE();
  closeHandler($this.r19());
}
function markClosed($this) {
  var tmp0 = $this.q18_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp;
      switch (convertToInt(shiftRight(cur, 60))) {
        case 0:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$3 = cur & 1152921504606846975n;
          tmp = constructSendersAndCloseStatus(tmp$ret$3, 2);
          break;
        case 1:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$4 = cur & 1152921504606846975n;
          tmp = constructSendersAndCloseStatus(tmp$ret$4, 3);
          break;
        default:
          return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function markCancelled($this) {
  var tmp0 = $this.q18_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var tmp$ret$2 = cur & 1152921504606846975n;
      var upd = constructSendersAndCloseStatus(tmp$ret$2, 3);
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function markCancellationStarted($this) {
  var tmp0 = $this.q18_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      if (convertToInt(shiftRight(cur, 60)) === 0) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$3 = cur & 1152921504606846975n;
        tmp = constructSendersAndCloseStatus(tmp$ret$3, 1);
      } else {
        return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function completeCloseOrCancel($this) {
  $this.q1a();
}
function completeClose($this, sendersCur) {
  var lastSegment = closeLinkedList($this);
  if ($this.s1a()) {
    var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
    if (!(lastBufferedCellGlobalIndex === -1n)) {
      $this.r1a(lastBufferedCellGlobalIndex);
    }
  }
  cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
  return lastSegment;
}
function completeCancel($this, sendersCur) {
  var lastSegment = completeClose($this, sendersCur);
  removeUnprocessedElements($this, lastSegment);
}
function closeLinkedList($this) {
  var lastSegment = $this.w18_1.kotlinx$atomicfu$value;
  // Inline function 'kotlin.let' call
  var it = $this.u18_1.kotlinx$atomicfu$value;
  if (it.d10_1 > lastSegment.d10_1)
    lastSegment = it;
  // Inline function 'kotlin.let' call
  var it_0 = $this.v18_1.kotlinx$atomicfu$value;
  if (it_0.d10_1 > lastSegment.d10_1)
    lastSegment = it_0;
  return close(lastSegment);
}
function markAllEmptyCellsAsClosed($this, lastSegment) {
  var segment = lastSegment;
  while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.d10_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        if (globalIndex < $this.v19())
          return -1n;
        cell_update: while (true) {
          var state = segment.k18(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.m18(index, state, get_CHANNEL_CLOSED())) {
              segment.c19();
              break cell_update;
            }
          } else if (state === get_BUFFERED())
            return globalIndex;
          else
            break cell_update;
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.l19();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return -1n;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
}
function removeUnprocessedElements($this, lastSegment) {
  var onUndeliveredElement = $this.p18_1;
  var undeliveredElementException = null;
  var suspendedSenders = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.d10_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        update_cell: while (true) {
          var state = segment.k18(index);
          if (state === get_DONE_RCV())
            break process_segments;
          else {
            if (state === get_BUFFERED()) {
              if (globalIndex < $this.v19())
                break process_segments;
              if (segment.m18(index, state, get_CHANNEL_CLOSED())) {
                if (!(onUndeliveredElement == null)) {
                  var element = segment.h18(index);
                  undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                }
                segment.j18(index);
                segment.c19();
                break update_cell;
              }
            } else {
              if (state === get_IN_BUFFER() || state === null) {
                if (segment.m18(index, state, get_CHANNEL_CLOSED())) {
                  segment.c19();
                  break update_cell;
                }
              } else {
                var tmp;
                if (!(state == null) ? isInterface(state, Waiter()) : false) {
                  tmp = true;
                } else {
                  tmp = state instanceof WaiterEB();
                }
                if (tmp) {
                  if (globalIndex < $this.v19())
                    break process_segments;
                  var tmp_0;
                  if (state instanceof WaiterEB()) {
                    tmp_0 = state.x19_1;
                  } else {
                    tmp_0 = (!(state == null) ? isInterface(state, Waiter()) : false) ? state : THROW_CCE();
                  }
                  var sender = tmp_0;
                  if (segment.m18(index, state, get_CHANNEL_CLOSED())) {
                    if (!(onUndeliveredElement == null)) {
                      var element_0 = segment.h18(index);
                      undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                    }
                    suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                    segment.j18(index);
                    segment.c19();
                    break update_cell;
                  }
                } else {
                  if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                    break process_segments;
                  else {
                    if (state === get_RESUMING_BY_EB())
                      continue update_cell;
                    else {
                      break update_cell;
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.l19();
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      break process_segments;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    segment = tmp_1;
  }
  var tmp0_0 = suspendedSenders;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList())) {
        var it = access$_get_holder__kkflen(tmp0_0);
        resumeSenderOnCancelledChannel($this, it);
      } else {
        var tmp_2 = access$_get_holder__kkflen(tmp0_0);
        var list = tmp_2 instanceof ArrayList() ? tmp_2 : THROW_CCE();
        var inductionVariable_0 = list.q2() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.r2(i);
            resumeSenderOnCancelledChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  var tmp1_safe_receiver = undeliveredElementException;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp1_safe_receiver;
  }
}
function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
  var suspendedReceivers = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (!(segment == null)) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.d10_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        if (add(this_0, fromInt(index)) < sendersCounter)
          break process_segments;
        cell_update: while (true) {
          var state = segment.k18(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.m18(index, state, get_CHANNEL_CLOSED())) {
              segment.c19();
              break cell_update;
            }
          } else {
            if (state instanceof WaiterEB()) {
              if (segment.m18(index, state, get_CHANNEL_CLOSED())) {
                suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.x19_1);
                segment.a19(index, true);
                break cell_update;
              }
            } else {
              if (!(state == null) ? isInterface(state, Waiter()) : false) {
                if (segment.m18(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                  segment.a19(index, true);
                  break cell_update;
                }
              } else {
                break cell_update;
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    segment = segment.l19();
  }
  var tmp0_0 = suspendedReceivers;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList())) {
        var it = access$_get_holder__kkflen(tmp0_0);
        resumeReceiverOnClosedChannel($this, it);
      } else {
        var tmp = access$_get_holder__kkflen(tmp0_0);
        var list = tmp instanceof ArrayList() ? tmp : THROW_CCE();
        var inductionVariable_0 = list.q2() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.r2(i);
            resumeReceiverOnClosedChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
}
function resumeReceiverOnClosedChannel($this, $receiver) {
  return resumeWaiterOnClosedChannel($this, $receiver, true);
}
function resumeSenderOnCancelledChannel($this, $receiver) {
  return resumeWaiterOnClosedChannel($this, $receiver, false);
}
function resumeWaiterOnClosedChannel($this, $receiver, receiver) {
  if ($receiver instanceof SendBroadcast()) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $receiver.e1a_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
    this_0.oc(tmp$ret$1);
  } else {
    if (isInterface($receiver, CancellableContinuation())) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = receiver ? _get_receiveException__foorc1($this) : $this.u19();
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
      $receiver.oc(tmp$ret$3);
    } else {
      if ($receiver instanceof ReceiveCatching()) {
        var tmp0 = $receiver.b1a_1;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = new (ChannelResult())(Companion_getInstance().t1a($this.r19()));
        var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
        tmp0.oc(tmp$ret$5);
      } else {
        if ($receiver instanceof BufferedChannelIterator()) {
          $receiver.k1a();
        } else {
          if (isInterface($receiver, SelectInstance()))
            $receiver.c1a($this, get_CHANNEL_CLOSED());
          else {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected waiter: ' + toString_0($receiver);
            throw IllegalStateException().o(toString_0(message));
          }
        }
      }
    }
  }
}
function _get_isClosedForSend0__kxgf9m($this, $receiver) {
  return isClosed($this, $receiver, false);
}
function _get_isClosedForReceive0__f7qknl($this, $receiver) {
  return isClosed($this, $receiver, true);
}
function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var tmp;
  switch (convertToInt(shiftRight(sendersAndCloseStatusCur, 60))) {
    case 0:
      tmp = false;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$1 = sendersAndCloseStatusCur & 1152921504606846975n;
      completeClose($this, tmp$ret$1);
      tmp = isClosedForReceive ? !$this.u1a() : true;
      break;
    case 3:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$2 = sendersAndCloseStatusCur & 1152921504606846975n;
      completeCancel($this, tmp$ret$2);
      tmp = true;
      break;
    default:
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

      // Inline function 'kotlin.error' call

      var message = 'unexpected close status: ' + convertToInt(shiftRight(sendersAndCloseStatusCur, 60));
      throw IllegalStateException().o(toString_0(message));
  }
  return tmp;
}
function isCellNonEmpty($this, segment, index, globalIndex) {
  while (true) {
    var state = segment.k18(index);
    if (state === null || state === get_IN_BUFFER()) {
      if (segment.m18(index, state, get_POISONED())) {
        expandBuffer($this);
        return false;
      }
    } else if (state === get_BUFFERED())
      return true;
    else if (state === get_INTERRUPTED_SEND())
      return false;
    else if (state === get_CHANNEL_CLOSED())
      return false;
    else if (state === get_DONE_RCV())
      return false;
    else if (state === get_POISONED())
      return false;
    else if (state === get_RESUMING_BY_EB())
      return true;
    else if (state === get_RESUMING_BY_RCV())
      return false;
    else
      return globalIndex === $this.v19();
  }
}
function findSegmentSend($this, id, startFrom) {
  var tmp0 = $this.u18_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.d10_1 >= tmp2.d10_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.e19()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.f19()) {
                cur.p6();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.f19()) {
              tmp2.p6();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.d10_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (multiply(tmp0_0, fromInt(other)) < $this.v19()) {
      startFrom.m19();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.d10_1 > id) {
      var tmp0_1 = segment.d10_1;
      // Inline function 'kotlin.Long.times' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$7 = multiply(tmp0_1, fromInt(other_0));
      updateSendersCounterIfLower($this, tmp$ret$7);
      var tmp0_2 = segment.d10_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      if (multiply(tmp0_2, fromInt(other_1)) < $this.v19()) {
        segment.m19();
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function findSegmentReceive($this, id, startFrom) {
  var tmp0 = $this.v18_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.d10_1 >= tmp2.d10_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.e19()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.f19()) {
                cur.p6();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.f19()) {
              tmp2.p6();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.d10_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (multiply(tmp0_0, fromInt(other)) < $this.s19()) {
      startFrom.m19();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
      var tmp0_1 = _get_bufferEndCounter__2d4hee($this);
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      tmp_1 = id <= divide(tmp0_1, fromInt(other_0));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp0_2 = $this.w18_1;
      $l$block_5: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        // Inline function 'kotlinx.atomicfu.loop' call
        while (true) {
          var cur_0 = tmp0_2.kotlinx$atomicfu$value;
          if (cur_0.d10_1 >= segment.d10_1) {
            break $l$block_5;
          }
          if (!segment.e19()) {
            break $l$block_5;
          }
          if (tmp0_2.atomicfu$compareAndSet(cur_0, segment)) {
            if (cur_0.f19()) {
              cur_0.p6();
            }
            break $l$block_5;
          }
          if (segment.f19()) {
            segment.p6();
          }
        }
      }
    }
    var tmp_2;
    if (segment.d10_1 > id) {
      var tmp0_3 = segment.d10_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$11 = multiply(tmp0_3, fromInt(other_1));
      updateReceiversCounterIfLower($this, tmp$ret$11);
      var tmp0_4 = segment.d10_1;
      // Inline function 'kotlin.Long.times' call
      var other_2 = get_SEGMENT_SIZE();
      if (multiply(tmp0_4, fromInt(other_2)) < $this.s19()) {
        segment.m19();
      }
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_2 = segment;
    }
    tmp_0 = tmp_2;
  }
  return tmp_0;
}
function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
  var tmp0 = $this.w18_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.d10_1 >= tmp2.d10_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.e19()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.f19()) {
                cur.p6();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.f19()) {
              tmp2.p6();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
    incCompletedExpandBufferAttempts($this);
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.d10_1 > id) {
      // Inline function 'kotlin.Long.plus' call
      var tmp_2 = add(currentBufferEndCounter, fromInt(1));
      var tmp0_0 = segment.d10_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      var tmp$ret$7 = multiply(tmp0_0, fromInt(other));
      if ($this.s18_1.atomicfu$compareAndSet(tmp_2, tmp$ret$7)) {
        var tmp0_1 = segment.d10_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$8 = multiply(tmp0_1, fromInt(other_0));
        incCompletedExpandBufferAttempts($this, subtract(tmp$ret$8, currentBufferEndCounter));
      } else {
        incCompletedExpandBufferAttempts($this);
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
  var segment = startFrom;
  $l$loop: while (segment.d10_1 < id) {
    var tmp0_elvis_lhs = segment.i19();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
  while (true) {
    $l$loop_0: while (segment.d19()) {
      var tmp1_elvis_lhs = segment.i19();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      segment = tmp_0;
    }
    var tmp0 = $this.w18_1;
    var tmp2 = segment;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.moveForward' call
      var tmp$ret$1;
      // Inline function 'kotlinx.atomicfu.loop' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur.d10_1 >= tmp2.d10_1) {
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (!tmp2.e19()) {
          tmp$ret$0 = false;
          break $l$block_1;
        }
        if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
          if (cur.f19()) {
            cur.p6();
          }
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (tmp2.f19()) {
          tmp2.p6();
        }
      }
      tmp$ret$0 = tmp$ret$1;
    }
    if (tmp$ret$0)
      return Unit_instance;
  }
}
function updateSendersCounterIfLower($this, value) {
  var tmp$ret$0;
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.q18_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var curCounter = cur & 1152921504606846975n;
    if (curCounter >= value)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp$ret$3 = convertToInt(shiftRight(cur, 60));
    var update = constructSendersAndCloseStatus(curCounter, tmp$ret$3);
    if ($this.q18_1.atomicfu$compareAndSet(cur, update))
      return Unit_instance;
  }
  return tmp$ret$0;
}
function updateReceiversCounterIfLower($this, value) {
  var tmp$ret$0;
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.r18_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    if (cur >= value)
      return Unit_instance;
    if ($this.r18_1.atomicfu$compareAndSet(cur, value))
      return Unit_instance;
  }
  return tmp$ret$0;
}
function bindCancellationFunResult($this, $receiver) {
  return BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($this);
}
function onCancellationChannelResultImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.p18_1), ensureNotNull(ChannelResult__getOrNull_impl_f5e07h(element)), context);
}
function bindCancellationFun($this, $receiver, element) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, context) => {
    callUndeliveredElement($receiver, element, context);
    return Unit_instance;
  };
}
function bindCancellationFun_0($this, $receiver) {
  return BufferedChannel$onCancellationImplDoNotCall$ref($this);
}
function onCancellationImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.p18_1), element, context);
}
function BufferedChannel$onCancellationChannelResultImplDoNotCall$ref(p0) {
  var l = (_this__u8e3s4, p0_0, p1) => {
    var tmp0 = p0;
    onCancellationChannelResultImplDoNotCall(tmp0, _this__u8e3s4, p0_0.w1a_1, p1);
    return Unit_instance;
  };
  l.callableName = 'onCancellationChannelResultImplDoNotCall';
  return l;
}
function BufferedChannel$onCancellationImplDoNotCall$ref(p0) {
  var l = (_this__u8e3s4, p0_0, p1) => {
    var tmp0 = p0;
    onCancellationImplDoNotCall(tmp0, _this__u8e3s4, p0_0, p1);
    return Unit_instance;
  };
  l.callableName = 'onCancellationImplDoNotCall';
  return l;
}
var BufferedChannelClass;
function BufferedChannel() {
  if (BufferedChannelClass === VOID) {
    class $ {
      constructor(capacity, onUndeliveredElement) {
        onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
        this.o18_1 = capacity;
        this.p18_1 = onUndeliveredElement;
        // Inline function 'kotlin.require' call
        if (!(this.o18_1 >= 0)) {
          var message = 'Invalid channel capacity: ' + this.o18_1 + ', should be >=0';
          throw IllegalArgumentException().n2(toString_0(message));
        }
        this.q18_1 = atomic$long$1(0n);
        this.r18_1 = atomic$long$1(0n);
        this.s18_1 = atomic$long$1(initialBufferEnd(this.o18_1));
        this.t18_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
        var firstSegment = new (ChannelSegment())(0n, null, this, 3);
        this.u18_1 = atomic$ref$1(firstSegment);
        this.v18_1 = atomic$ref$1(firstSegment);
        var tmp = this;
        var tmp_0;
        if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
          var tmp_1 = get_NULL_SEGMENT();
          tmp_0 = tmp_1 instanceof ChannelSegment() ? tmp_1 : THROW_CCE();
        } else {
          tmp_0 = firstSegment;
        }
        tmp.w18_1 = atomic$ref$1(tmp_0);
        var tmp_2 = this;
        var tmp_3;
        if (this.p18_1 == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_3 = (select, _unused_var__etf5q3, element) => (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) => {
            var tmp;
            if (!(element === get_CHANNEL_CLOSED())) {
              callUndeliveredElement(this.p18_1, element, select.mc());
              tmp = Unit_instance;
            }
            return Unit_instance;
          };
        }
        tmp_2.x18_1 = tmp_3;
        this.y18_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
        this.z18_1 = atomic$ref$1(null);
      }
      s19() {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        return this.q18_1.kotlinx$atomicfu$value & 1152921504606846975n;
      }
      v19() {
        return this.r18_1.kotlinx$atomicfu$value;
      }
      *x1a(element, $completion) {
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment = this.u18_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = this.q18_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s = sendersAndCloseStatusCur & 1152921504606846975n;
            var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(s, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(s, fromInt(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment.d10_1 === id)) {
              var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
                  break $l$block_5;
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment = tmp;
            }
            switch (updateCellSend(this, segment, i, element, s, null, closed)) {
              case 0:
                segment.m19();
                break $l$block_5;
              case 1:
                break $l$block_5;
              case 2:
                if (closed) {
                  segment.c19();
                  yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
                  break $l$block_5;
                }

                var tmp2_safe_receiver = (!(null == null) ? isInterface(null, Waiter()) : false) ? null : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
                }

                // Inline function 'kotlinx.coroutines.assert' call

                break $l$block_5;
              case 4:
                if (s < this.v19()) {
                  segment.m19();
                }

                yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
                break $l$block_5;
              case 5:
                segment.m19();
                continue $l$loop_0;
              case 3:
                var segm = segment;
                yield* /*#__NOINLINE__*/sendOnNoWaiterSuspend(this, segm, i, element, s, $completion);
                break $l$block_5;
            }
          }
        }
        return Unit_instance;
      }
      y1a(element) {
        if (shouldSendSuspend0(this, this.q18_1.kotlinx$atomicfu$value))
          return Companion_getInstance().z1a();
        var tmp4 = get_INTERRUPTED_SEND();
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment = this.u18_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = this.q18_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s = sendersAndCloseStatusCur & 1152921504606846975n;
            var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(s, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(s, fromInt(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment.d10_1 === id)) {
              var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  tmp$ret$0 = Companion_getInstance().t1a(this.u19());
                  break $l$block_5;
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment = tmp;
            }
            switch (updateCellSend(this, segment, i, element, s, tmp4, closed)) {
              case 0:
                segment.m19();
                tmp$ret$0 = Companion_getInstance().a1a(Unit_instance);
                break $l$block_5;
              case 1:
                tmp$ret$0 = Companion_getInstance().a1a(Unit_instance);
                break $l$block_5;
              case 2:
                if (closed) {
                  segment.c19();
                  tmp$ret$0 = Companion_getInstance().t1a(this.u19());
                  break $l$block_5;
                }

                var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter()) : false) ? tmp4 : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
                }

                segment.c19();
                tmp$ret$0 = Companion_getInstance().z1a();
                break $l$block_5;
              case 4:
                if (s < this.v19()) {
                  segment.m19();
                }

                tmp$ret$0 = Companion_getInstance().t1a(this.u19());
                break $l$block_5;
              case 5:
                segment.m19();
                continue $l$loop_0;
              case 3:
                // Inline function 'kotlin.error' call

                var message = 'unexpected';
                throw IllegalStateException().o(toString_0(message));
            }
          }
        }
        return tmp$ret$0;
      }
      a1b(element) {
        var tmp4 = get_BUFFERED();
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment = this.u18_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = this.q18_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s = sendersAndCloseStatusCur & 1152921504606846975n;
            var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(s, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(s, fromInt(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment.d10_1 === id)) {
              var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  return Companion_getInstance().t1a(this.u19());
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment = tmp;
            }
            switch (updateCellSend(this, segment, i, element, s, tmp4, closed)) {
              case 0:
                segment.m19();
                return Companion_getInstance().a1a(Unit_instance);
              case 1:
                return Companion_getInstance().a1a(Unit_instance);
              case 2:
                if (closed) {
                  segment.c19();
                  return Companion_getInstance().t1a(this.u19());
                }

                var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter()) : false) ? tmp4 : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
                }

                var tmp0 = segment.d10_1;
                // Inline function 'kotlin.Long.times' call

                var other_1 = get_SEGMENT_SIZE();
                // Inline function 'kotlin.Long.plus' call

                var this_0 = multiply(tmp0, fromInt(other_1));
                var tmp$ret$10 = add(this_0, fromInt(i));
                this.r1a(tmp$ret$10);
                return Companion_getInstance().a1a(Unit_instance);
              case 4:
                if (s < this.v19()) {
                  segment.m19();
                }

                return Companion_getInstance().t1a(this.u19());
              case 5:
                segment.m19();
                continue $l$loop_0;
              case 3:
                // Inline function 'kotlin.error' call

                var message = 'unexpected';
                throw IllegalStateException().o(toString_0(message));
            }
          }
        }
        return tmp$ret$0;
      }
      d1a() {
      }
      w19() {
      }
      *b1b($completion) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment = this.v18_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (this.t19()) {
              throw recoverStackTrace(_get_receiveException__foorc1(this));
            }
            var r = this.r18_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(r, fromInt(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment.d10_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment = tmp;
            }
            var updCellResult = updateCellReceive(this, segment, i, r, null);
            var tmp_0;
            if (updCellResult === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(null == null) ? isInterface(null, Waiter()) : false) ? null : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this, tmp1_safe_receiver, segment, i);
              }
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException().o(toString_0(message));
            } else if (updCellResult === get_FAILED()) {
              if (r < this.s19()) {
                segment.m19();
              }
              continue $l$loop_0;
            } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
              var segm = segment;
              tmp_0 = yield* /*#__NOINLINE__*/receiveOnNoWaiterSuspend(this, segm, i, r, $completion);
            } else {
              segment.m19();
              return updCellResult;
            }
            tmp$ret$0 = tmp_0;
            break $l$block_0;
          }
        }
        return tmp$ret$0;
      }
      r1a(globalCellIndex) {
        // Inline function 'kotlinx.coroutines.assert' call
        var segment = this.v18_1.kotlinx$atomicfu$value;
        $l$loop_0: while (true) {
          var r = this.r18_1.kotlinx$atomicfu$value;
          // Inline function 'kotlin.Long.plus' call
          var other = this.o18_1;
          var tmp0 = add(r, fromInt(other));
          // Inline function 'kotlin.math.max' call
          var b = _get_bufferEndCounter__2d4hee(this);
          if (globalCellIndex < (tmp0 >= b ? tmp0 : b))
            return Unit_instance;
          // Inline function 'kotlin.Long.plus' call
          var tmp$ret$3 = add(r, fromInt(1));
          if (!this.r18_1.atomicfu$compareAndSet(r, tmp$ret$3))
            continue $l$loop_0;
          // Inline function 'kotlin.Long.div' call
          var other_0 = get_SEGMENT_SIZE();
          var id = divide(r, fromInt(other_0));
          // Inline function 'kotlin.Long.rem' call
          var other_1 = get_SEGMENT_SIZE();
          var tmp$ret$5 = modulo(r, fromInt(other_1));
          var i = convertToInt(tmp$ret$5);
          if (!(segment.d10_1 === id)) {
            var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment = tmp;
          }
          var updCellResult = updateCellReceive(this, segment, i, r, null);
          if (updCellResult === get_FAILED()) {
            if (r < this.s19()) {
              segment.m19();
            }
          } else {
            segment.m19();
            var tmp1_safe_receiver = this.p18_1;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp1_safe_receiver, updCellResult);
            if (tmp2_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              throw tmp2_safe_receiver;
            }
          }
        }
      }
      b19(globalIndex) {
        if (_get_isRendezvousOrUnlimited__3mdufi(this))
          return Unit_instance;
        while (_get_bufferEndCounter__2d4hee(this) <= globalIndex) {
        }
        // Inline function 'kotlin.repeat' call
        var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var b = _get_bufferEndCounter__2d4hee(this);
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var ebCompleted = this.t18_1.kotlinx$atomicfu$value & 4611686018427387903n;
            if (b === ebCompleted && b === _get_bufferEndCounter__2d4hee(this))
              return Unit_instance;
          }
           while (inductionVariable < times);
        var tmp0 = this.t18_1;
        $l$block: {
          // Inline function 'kotlinx.atomicfu.update' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var tmp$ret$5 = cur & 4611686018427387903n;
            var upd = constructEBCompletedAndPauseFlag(tmp$ret$5, true);
            if (tmp0.atomicfu$compareAndSet(cur, upd)) {
              break $l$block;
            }
          }
        }
        while (true) {
          var b_0 = _get_bufferEndCounter__2d4hee(this);
          var ebCompletedAndBit = this.t18_1.kotlinx$atomicfu$value;
          // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
          var ebCompleted_0 = ebCompletedAndBit & 4611686018427387903n;
          // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
          var pauseExpandBuffers = !((ebCompletedAndBit & 4611686018427387904n) === 0n);
          if (b_0 === ebCompleted_0 && b_0 === _get_bufferEndCounter__2d4hee(this)) {
            var tmp0_0 = this.t18_1;
            $l$block_0: {
              // Inline function 'kotlinx.atomicfu.update' call
              while (true) {
                var cur_0 = tmp0_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
                var tmp$ret$10 = cur_0 & 4611686018427387903n;
                var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$10, false);
                if (tmp0_0.atomicfu$compareAndSet(cur_0, upd_0)) {
                  break $l$block_0;
                }
              }
            }
            return Unit_instance;
          }
          if (!pauseExpandBuffers) {
            this.t18_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
          }
        }
      }
      p1() {
        return new (BufferedChannelIterator())(this);
      }
      r19() {
        var tmp = this.y18_1.kotlinx$atomicfu$value;
        return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
      }
      u19() {
        var tmp0_elvis_lhs = this.r19();
        return tmp0_elvis_lhs == null ? ClosedSendChannelException().g1b('Channel was closed') : tmp0_elvis_lhs;
      }
      h1b() {
      }
      i1b(cause) {
        return this.j1b(cause, false);
      }
      hx(cause) {
        this.l1b(cause);
      }
      l1b(cause) {
        return this.j1b(cause == null ? CancellationException().n('Channel was cancelled') : cause, true);
      }
      j1b(cause, cancel) {
        if (cancel) {
          markCancellationStarted(this);
        }
        var closedByThisOperation = this.y18_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
        if (cancel) {
          markCancelled(this);
        } else {
          markClosed(this);
        }
        completeCloseOrCancel(this);
        // Inline function 'kotlin.also' call
        this.h1b();
        if (closedByThisOperation) {
          invokeCloseHandler(this);
        }
        return closedByThisOperation;
      }
      s1a() {
        return false;
      }
      q1a() {
        return _get_isClosedForSend0__kxgf9m(this, this.q18_1.kotlinx$atomicfu$value);
      }
      t19() {
        return _get_isClosedForReceive0__f7qknl(this, this.q18_1.kotlinx$atomicfu$value);
      }
      u1a() {
        $l$loop: while (true) {
          var segment = this.v18_1.kotlinx$atomicfu$value;
          var r = this.v19();
          var s = this.s19();
          if (s <= r)
            return false;
          // Inline function 'kotlin.Long.div' call
          var other = get_SEGMENT_SIZE();
          var id = divide(r, fromInt(other));
          if (!(segment.d10_1 === id)) {
            var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              var tmp_0;
              if (this.v18_1.kotlinx$atomicfu$value.d10_1 < id) {
                return false;
              } else {
                continue $l$loop;
              }
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment = tmp;
          }
          segment.m19();
          // Inline function 'kotlin.Long.rem' call
          var other_0 = get_SEGMENT_SIZE();
          var tmp$ret$1 = modulo(r, fromInt(other_0));
          var i = convertToInt(tmp$ret$1);
          if (isCellNonEmpty(this, segment, i, r))
            return true;
          // Inline function 'kotlin.Long.plus' call
          var tmp$ret$2 = add(r, fromInt(1));
          this.r18_1.atomicfu$compareAndSet(r, tmp$ret$2);
        }
      }
      toString() {
        var sb = StringBuilder().l1();
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        var this_0 = this.q18_1.kotlinx$atomicfu$value;
        var tmp0_subject = convertToInt(shiftRight(this_0, 60));
        if (tmp0_subject === 2) {
          sb.m1('closed,');
        } else if (tmp0_subject === 3) {
          sb.m1('cancelled,');
        }
        sb.m1('capacity=' + this.o18_1 + ',');
        sb.m1('data=[');
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = listOf([this.v18_1.kotlinx$atomicfu$value, this.u18_1.kotlinx$atomicfu$value, this.w18_1.kotlinx$atomicfu$value]);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().p2();
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (!(element === get_NULL_SEGMENT())) {
            destination.i2(element);
          }
        }
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.minBy' call
          var iterator = destination.p1();
          if (!iterator.q1())
            throw NoSuchElementException().t6();
          var minElem = iterator.r1();
          if (!iterator.q1()) {
            tmp$ret$4 = minElem;
            break $l$block;
          }
          var minValue = minElem.d10_1;
          do {
            var e = iterator.r1();
            var v = e.d10_1;
            if (compareTo(minValue, v) > 0) {
              minElem = e;
              minValue = v;
            }
          }
           while (iterator.q1());
          tmp$ret$4 = minElem;
        }
        var firstSegment = tmp$ret$4;
        var r = this.v19();
        var s = this.s19();
        var segment = firstSegment;
        append_elements: while (true) {
          var inductionVariable = 0;
          var last_0 = get_SEGMENT_SIZE();
          if (inductionVariable < last_0)
            process_cell: do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_0 = segment.d10_1;
              // Inline function 'kotlin.Long.times' call
              var other = get_SEGMENT_SIZE();
              // Inline function 'kotlin.Long.plus' call
              var this_1 = multiply(tmp0_0, fromInt(other));
              var globalCellIndex = add(this_1, fromInt(i));
              if (globalCellIndex >= s && globalCellIndex >= r)
                break append_elements;
              var cellState = segment.k18(i);
              var element_0 = segment.h18(i);
              var tmp;
              if (!(cellState == null) ? isInterface(cellState, CancellableContinuation()) : false) {
                tmp = globalCellIndex < r && globalCellIndex >= s ? 'receive' : globalCellIndex < s && globalCellIndex >= r ? 'send' : 'cont';
              } else {
                if (!(cellState == null) ? isInterface(cellState, SelectInstance()) : false) {
                  tmp = globalCellIndex < r && globalCellIndex >= s ? 'onReceive' : globalCellIndex < s && globalCellIndex >= r ? 'onSend' : 'select';
                } else {
                  if (cellState instanceof ReceiveCatching()) {
                    tmp = 'receiveCatching';
                  } else {
                    if (cellState instanceof SendBroadcast()) {
                      tmp = 'sendBroadcast';
                    } else {
                      if (cellState instanceof WaiterEB()) {
                        tmp = 'EB(' + cellState.toString() + ')';
                      } else {
                        if (equals(cellState, get_RESUMING_BY_RCV()) || equals(cellState, get_RESUMING_BY_EB())) {
                          tmp = 'resuming_sender';
                        } else {
                          if (cellState == null || (equals(cellState, get_IN_BUFFER()) || equals(cellState, get_DONE_RCV())) || (equals(cellState, get_POISONED()) || equals(cellState, get_INTERRUPTED_RCV()) || (equals(cellState, get_INTERRUPTED_SEND()) || equals(cellState, get_CHANNEL_CLOSED())))) {
                            continue process_cell;
                          } else {
                            tmp = toString_0(cellState);
                          }
                        }
                      }
                    }
                  }
                }
              }
              var cellStateString = tmp;
              if (!(element_0 == null)) {
                sb.m1('(' + cellStateString + ',' + toString(element_0) + '),');
              } else {
                sb.m1(cellStateString + ',');
              }
            }
             while (inductionVariable < last_0);
          var tmp2_elvis_lhs = segment.i19();
          var tmp_0;
          if (tmp2_elvis_lhs == null) {
            break append_elements;
          } else {
            tmp_0 = tmp2_elvis_lhs;
          }
          segment = tmp_0;
        }
        if (last(sb) === _Char___init__impl__6a9atx(44)) {
          sb.wg(sb.a() - 1 | 0);
        }
        sb.m1(']');
        return sb.toString();
      }
    }
    protoOf($).k1b = close$default;
    protoOf($).m1b = cancel$default;
    initMetadataForClass($, 'BufferedChannel', VOID, VOID, [ReceiveChannel(), SendChannel()], [1, 4, 0, 3]);
    BufferedChannelClass = $;
  }
  return BufferedChannelClass;
}
var WaiterEBClass;
function WaiterEB() {
  if (WaiterEBClass === VOID) {
    class $ {
      constructor(waiter) {
        this.x19_1 = waiter;
      }
      toString() {
        return 'WaiterEB(' + toString_0(this.x19_1) + ')';
      }
    }
    initMetadataForClass($, 'WaiterEB');
    WaiterEBClass = $;
  }
  return WaiterEBClass;
}
function initialBufferEnd(capacity) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  switch (capacity) {
    case 0:
      return 0n;
    case 2147483647:
      return 9223372036854775807n;
    default:
      return fromInt(capacity);
  }
}
var ReceiveCatchingClass;
function ReceiveCatching() {
  if (ReceiveCatchingClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ReceiveCatching', VOID, VOID, [Waiter()]);
    ReceiveCatchingClass = $;
  }
  return ReceiveCatchingClass;
}
function tryResume0(_this__u8e3s4, value, onCancellation) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  _init_properties_BufferedChannel_kt__d6uc4y();
  // Inline function 'kotlin.let' call
  var token = _this__u8e3s4.bz(value, null, onCancellation);
  var tmp;
  if (!(token == null)) {
    _this__u8e3s4.cz(token);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function constructEBCompletedAndPauseFlag(counter, pauseEB) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(pauseEB ? 4611686018427387904n : 0n, counter);
}
function constructSendersAndCloseStatus(counter, closeStatus) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(shiftLeft(fromInt(closeStatus), 60), counter);
}
function createSegmentFunction() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return createSegment$ref();
}
function createSegment(id, prev) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return new (ChannelSegment())(id, prev, prev.e18(), 0);
}
function createSegment$ref() {
  var l = (p0, p1) => createSegment(p0, p1);
  l.callableName = 'createSegment';
  return l;
}
var properties_initialized_BufferedChannel_kt_58tjvw;
function _init_properties_BufferedChannel_kt__d6uc4y() {
  if (!properties_initialized_BufferedChannel_kt_58tjvw) {
    properties_initialized_BufferedChannel_kt_58tjvw = true;
    NULL_SEGMENT = new (ChannelSegment())(-1n, null, null, 0);
    SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
    EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
    BUFFERED = new (Symbol())('BUFFERED');
    IN_BUFFER = new (Symbol())('SHOULD_BUFFER');
    RESUMING_BY_RCV = new (Symbol())('S_RESUMING_BY_RCV');
    RESUMING_BY_EB = new (Symbol())('RESUMING_BY_EB');
    POISONED = new (Symbol())('POISONED');
    DONE_RCV = new (Symbol())('DONE_RCV');
    INTERRUPTED_SEND = new (Symbol())('INTERRUPTED_SEND');
    INTERRUPTED_RCV = new (Symbol())('INTERRUPTED_RCV');
    CHANNEL_CLOSED = new (Symbol())('CHANNEL_CLOSED');
    SUSPEND = new (Symbol())('SUSPEND');
    SUSPEND_NO_WAITER = new (Symbol())('SUSPEND_NO_WAITER');
    FAILED = new (Symbol())('FAILED');
    NO_RECEIVE_RESULT = new (Symbol())('NO_RECEIVE_RESULT');
    CLOSE_HANDLER_CLOSED = new (Symbol())('CLOSE_HANDLER_CLOSED');
    CLOSE_HANDLER_INVOKED = new (Symbol())('CLOSE_HANDLER_INVOKED');
    NO_CLOSE_CAUSE = new (Symbol())('NO_CLOSE_CAUSE');
  }
}
//region block: exports
export {
  BufferedChannel as BufferedChannel3lgkhzot5gmk6,
};
//endregion

//# sourceMappingURL=BufferedChannel.mjs.map
